import React, { createContext, useContext } from 'react'

export type PortalsState = {
  [key: string]: any
}

export const ReactNodeViewPortalsContext = createContext<
  | {
      createPortal: (portal: React.ReactPortal) => void
      removePortal: (key: string) => void
      state: Partial<PortalsState>
    }
  | undefined
>(undefined)

export const useReactNodeViewPortals = () => {
  const context = useContext(ReactNodeViewPortalsContext)

  if (context === undefined) {
    throw new Error('useReacNodeViewPortals must be within ReactNodeViewPortalProvider')
  }

  return context
}
